import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const configTableSelector = createSelector(
  selector,
  store => store.mode,
);

export const adminRoleSelector = createSelector(
  selector,
  store => store.isAdminRole,
);

export const configViewSelector = createSelector(
  selector,
  store => store.sort,
);

export const warningModalSelector = createSelector(
  selector,
  store => store.visible,
);
